var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m325.007 242.86 7.255-2.352-18.19-56.1-7.255 2.352 18.19 56.1Z",
    fill: "#6977F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m325.006 242.86 7.255-2.353-.472 10.907-6.783-8.554Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m331.788 251.414.222-5.124-3.408 1.105 3.186 4.019Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M358.431 342.907v-7.587h9.283v-5.195h-101.87v17.977h101.87v-5.195h-9.283Z",
    fill: "#1D288E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M360.596 335.32h-79.727v7.585h79.727v-7.585Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M346.179 325.244v-7.125h4.648v-4.881H286v16.888h64.827v-4.882h-4.648Z",
    fill: "#384BF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M346.18 318.119h-55.071v7.125h55.071v-7.125Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m360.453 299.619-2.297 1.422 1.824 3.034-8.857 5.258-1.788-2.831-2.321 1.436 23.604 37.986 13.439-8.317-23.604-37.988Z",
    fill: "#1D288E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m359.98 304.074.003.003-8.86 5.255 19.045 30.648 8.756-5.419-18.944-30.487Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M440.684 361.879v-16.108H254.001v16.108h186.683Z",
    fill: "#6977F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.735 266.271h-16.104v239.814h16.104V266.271Zm-109.655 0h-16.103v239.814h16.103V266.271Z",
    fill: "#818181"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M482.58 274.325v-16.108H186.851v16.108H482.58Z",
    fill: "#6977F7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M482.582 506.084v-16.107H199.81v16.107h282.772Z",
    fill: "#818181"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.756 506.084v-16.107h-20.943v16.107h20.943Zm276.619.001v-16.108h-20.943v16.108h20.943Zm-109.909-84.919v51.689h-18.111v-33.62c0-9.979 8.109-18.069 18.111-18.069Zm118.491 0v51.689h18.111v-33.62c0-9.979-8.108-18.069-18.111-18.069Zm-37.064-91.767h-7.672v-18.602c0-7.951-6.483-14.419-14.453-14.419-7.969 0-14.451 6.468-14.451 14.419v18.602h-7.672v-18.602c-.004-12.171 9.922-22.072 22.122-22.072s22.126 9.901 22.126 22.072v18.602Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M506.084 472.854H375.451v-87.24c0-35.986 29.243-65.161 65.318-65.161 36.072 0 65.317 29.173 65.317 65.161v87.24h-.002Z",
    fill: "#1D288E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.587 373.742h-7.639c-20.201 0-36.579 16.337-36.579 36.491v44.112h80.795v-44.112c.001-20.154-16.376-36.491-36.577-36.491Z",
    fill: "#384BF5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M440.769 393.08c9.074 0 16.429-7.338 16.429-16.389 0-9.052-7.355-16.39-16.429-16.39-9.074 0-16.429 7.338-16.429 16.39 0 9.051 7.355 16.389 16.429 16.389Z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M131.698 358.449H115.51v141.318h16.188V358.449Z",
    fill: "#818181"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.13 232.826v114.325c0 10.413 8.422 18.863 18.83 18.893l81.309.23v16.195l-86.514-.244c-16.48-.045-29.816-13.426-29.816-29.913l.002-119.486h16.19Z",
    fill: "#818181"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m51.769 366.217-.124-16.196 110.416.33v16.195l-110.292-.329Zm-10.677-48.011-16.188.124.33-108.053H41.42l-.329 107.929Z",
    fill: "#6977F7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m62.702 505.755-.124-16.194 118.741.327v16.196l-118.617-.329Z",
    fill: "#818181"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.311 505.92v-16.195h-21.052v16.195h21.052Zm-104.361 0v-16.195H60.896v16.195H81.95ZM24.905 232.826H8.717v21.062h16.188v-21.062Zm440.993-61.865-19.939 57.986 6.743 2.31 19.939-57.986-6.743-2.31Z",
    fill: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m447.557 147.663-4.842 5.224 22.499 20.78 4.842-5.224-22.499-20.78Zm6.09 91.153h-7.129v14.734h7.129v-14.734Z",
    fill: "#000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M443.909 146.252h-21.466v7.116h21.466v-7.116Z",
    fill: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 252.602h-69.638v5.616h69.638v-5.616Z",
    fill: "#384BF5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M428.015 139.114c-3.933-4.311-10.62-4.626-14.934-.701l-14.555 13.236 14.245 15.611 14.555-13.237c4.313-3.922 4.622-10.598.689-14.909Z",
    fill: "#1D288E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m415.384 164.865-14.226-15.589c-11.167-5.841-25.242-4.485-35.093 4.474l-.331.301 41.595 45.582.331-.302c9.852-8.958 12.512-22.822 7.724-34.466Z",
    fill: "#384BF5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M457.55 226.957h-15.335v14.891h15.335v-14.891Z",
    fill: "#1D288E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M444.555 156.644c3.78 0 6.845-3.059 6.845-6.833 0-3.773-3.065-6.832-6.845-6.832-3.781 0-6.846 3.059-6.846 6.832 0 3.774 3.065 6.833 6.846 6.833Zm24.72 22.299c3.781 0 6.846-3.059 6.846-6.833s-3.065-6.833-6.846-6.833c-3.78 0-6.845 3.059-6.845 6.833s3.065 6.833 6.845 6.833Z",
    fill: "#384BF5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M367.17 252.225h-71.363v5.447h71.363v-5.447Z",
    fill: "#818181"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M441.256 307.245a5.448 5.448 0 1 0 0-10.896 5.448 5.448 0 0 0 0 10.896Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M198.871 202.652c-5.822-14.384-4.879-28.324-4.879-28.324s10.381 9.382 16.202 23.766c5.82 14.384 4.879 28.324 4.879 28.324s-10.381-9.382-16.202-23.766Zm42.001 1.608c-7.963 13.324-19.663 21.007-19.663 21.007s1.211-13.92 9.175-27.243c7.964-13.323 19.663-21.006 19.663-21.006s-1.212 13.919-9.175 27.242Zm-19.842-36.805c3.354-12.576 11.023-21.459 11.023-21.459s2.231 11.508-1.123 24.085c-3.353 12.577-11.023 21.46-11.023 21.46s-2.232-11.51 1.123-24.086Zm-11.905 2.308c-2.538-8.048-1.429-15.566-1.429-15.566s5.226 5.53 7.764 13.578c2.538 8.048 1.429 15.566 1.429 15.566s-5.225-5.53-7.764-13.578Z",
    fill: "#000"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.043 234.792c-.905-22.832 2.016-47.634 2.045-47.882l.853.101c-.03.248-2.943 24.984-2.041 47.748l-.857.033Z",
    fill: "#000"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M217.994 233.245c-1.872-5.892-4.434-8.634-4.459-8.661l.622-.59c.109.115 2.718 2.893 4.655 8.992l-.818.259Z",
    fill: "#000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m218.843 233.3-.771-.376c.331-.674 3.17-8.227 4.625-12.127l.805.299c-.173.461-4.227 11.324-4.659 12.204Zm.252-36.226c-.009-5.121-3.182-15.284-3.214-15.386l.819-.256c.132.422 3.244 10.39 3.253 15.641l-.858.001Z",
    fill: "#000"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M224.932 259.852h-12.474c-4.821 0-8.861-3.631-9.352-8.405l-3.432-27.242h37.553l-2.93 27.106c-.426 4.833-4.492 8.541-9.365 8.541Z",
    fill: "#384BF5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239.697 222.809h-42.492v2.793h42.492v-2.793Z",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.ba1c261996437211febf78536bde43b5.svg";
export { ForwardRef as ReactComponent };